import { render, staticRenderFns } from "./PaymentEdit.vue?vue&type=template&id=036558de"
import script from "./PaymentEdit.vue?vue&type=script&lang=js"
export * from "./PaymentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('036558de')) {
      api.createRecord('036558de', component.options)
    } else {
      api.reload('036558de', component.options)
    }
    module.hot.accept("./PaymentEdit.vue?vue&type=template&id=036558de", function () {
      api.rerender('036558de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/company/PaymentEdit.vue"
export default component.exports